// extracted by mini-css-extract-plugin
module.exports = {"MessageArea":"MessageLoading_MessageArea__1vkc0","LoadingDot":"MessageLoading_LoadingDot__rmNvb","loading":"MessageLoading_loading__gGqZH"};